import React from 'react';
import {Link} from 'react-router-dom';

const MarketingFooter: React.FC = () => {
  return (
    <footer className="border-t border-gray-700 bg-gray-800">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <h3 className="text-lg font-semibold text-white">CensorMe</h3>
            <p className="mt-2 text-sm text-gray-400">
                            Auto censor your audio so you can focus on making the fun stuff.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">Product</h4>
            <ul className="mt-4 space-y-2">
              <li><Link to="/#features" className="text-sm text-gray-400 hover:text-white transition-colors">Features</Link></li>
              <li><Link to="/#pricing" className="text-sm text-gray-400 hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/docs" className="text-sm text-gray-400 hover:text-white transition-colors">Documentation</Link></li>
              <li><Link to="/downloads" className="text-sm text-gray-400 hover:text-white transition-colors">Download Mapper</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">Company</h4>
            <ul className="mt-4 space-y-2">
              <li><Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">Legal</h4>
            <ul className="mt-4 space-y-2">
              <li><Link to="/terms" className="text-sm text-gray-400 hover:text-white transition-colors">Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-700 pt-8 text-center">
          <p className="text-sm text-gray-400">
                        &copy; {new Date().getFullYear()} CensorMe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
